export default __webpack_public_path__ + "static/media/ic-twitter.56ab8bf3.svg";